import { z } from "zod";
import { baseEntity, slugInput, tagsSchema } from "./common.js";

export const projectLink = z.object({
  label: z.string().min(1).max(60),
  url: z.string().min(1).max(500),
});
export type ProjectLink = z.infer<typeof projectLink>;

export const project = baseEntity.extend({
  /** e.g. "Open source", "CLI". */
  tag: z.string().min(1).max(60),
  name: z.string().min(1).max(120),
  description: z.string().min(1).max(600),
  /** Handwritten marker note, e.g. "currently shipping — v0.5.0". */
  markerNote: z.string().max(160).nullable(),
  links: z.array(projectLink).max(6),
});
export type Project = z.infer<typeof project>;

export const projectInput = z.object({
  tag: z.string().min(1).max(60),
  name: z.string().min(1).max(120),
  description: z.string().min(1).max(600),
  markerNote: z.string().max(160).nullable().default(null),
  links: z.array(projectLink).max(6).default([]),
  slug: slugInput,
  tags: tagsSchema.default([]),
  published: z.boolean().default(true),
  sortOrder: z.number().int().default(0),
});
export type ProjectInput = z.infer<typeof projectInput>;

export const projectUpdate = projectInput.partial();
export type ProjectUpdate = z.infer<typeof projectUpdate>;
